import React from 'react';
import { connect } from 'react-redux';

import { HeaderPanel } from 'apps/auth/components/common/Layout/HeaderPanel/HeaderPanel';
import ModalComponent from 'apps/auth/components/utils/ModalComponent';

import PanelForAddNewAccount from '../addNewAccount/PanelForAddNewAccount';

const AddNewAccountModal = (props) => {
    let panels = (
        <>
            {props.availableAccounts.map((account, i) => (
                <PanelForAddNewAccount key={account + i} account={account} getCurrencyIcon={props.getCurrencyIcon} onError={props.onError} />
            ))}
        </>
    );

    return (
        <ModalComponent isIconClose>
            <HeaderPanel title={props.openNewAccountTitle} />
            {panels}
        </ModalComponent>
    );
};

const mapStateToProps = (state) => {
    return {
        availableAccounts: state.extra.availableAccounts,
        openNewAccountTitle: state.messages.pageMessages.openNewAccountTitle,
    };
};

export default connect(mapStateToProps)(AddNewAccountModal);
